import { useEffect, useState } from 'react';
import { fetchIsLoggedIn } from './public.api';

export const useLoggedIn = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      setIsLoggedIn(await fetchIsLoggedIn());
    };
    fetch();
  }, []);

  return isLoggedIn;
};
